import { redirect } from 'react-router-dom';
import authLoader from './authLoader';

const adminLoader = async () => {
	const { user } = await authLoader();
	if (!user.permissions.isSystemAdmin && !user.permissions.isLocalAdmin) {
		throw redirect('/');
	}
	return user;
};

export default adminLoader;
